import styled, { css } from 'styled-components';
import media from 'src/styles/Media.styled';
import { isMobileDevice } from 'src/utils/util';
import { scrollBarStyle } from 'src/styles/CommonStyles.styled';

const isMobile = isMobileDevice();

export const FilterWrapperMain = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    width: 400px;
    height: ${({ isOrderResultPopUp, bannerHeight }) =>
        isOrderResultPopUp
            ? bannerHeight
                ? `calc(71vh - ${bannerHeight})`
                : '71vh'
            : bannerHeight
            ? `calc(78vh - ${bannerHeight})`
            : '78vh'};
    align-self: center;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    overflow: hidden;
    z-index: 3000;
    ${media.mediumDevice`
        width: 360px;
    `}
    ${media.mobileDevice`
		height: 100vh;
		width: 100vw;
		max-width: none;
        padding-bottom: ${({ keyboardPaddingBottom }) => keyboardPaddingBottom};
    `}

  
    @media screen and (orientation: landscape) and (max-width: 1366px) {
        height: ${({bannerHeight}) =>
        bannerHeight ? `calc(70vh - ${bannerHeight})` : '70vh'};
    }
    @media screen and (orientation: landscape) and (max-width: 1024px) {
        height: ${({bannerHeight}) =>
        bannerHeight ? `calc(70vh - ${bannerHeight})` : '70vh'};
    }
    ////

    @media screen and (orientation: landscape) {
        ${isMobile &&
        css`
            height: 65vh;
        `}
    }
`;

export const FilterContentMain = styled.div`
    display: flex;
    flex-direction: column;
    background: #f5f5f5 !important;
    height: 100vh;
    width: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    ${scrollBarStyle}
`;

export const FilterHeading = styled.p`
    color: #140f4b;
    font-size: 24px;
    font-family: AvenirNextWorld bold;
    margin: 0;
    letter-spacing: 0;
`;

export const Reset = styled.p`
    color: #1010eb;
    font-size: 15px;
    font-family: AvenirNextWorld Demi;
    margin: 0;
    padding-right: 1.3em;
    align-self: center;
    &:hover {
        cursor: pointer;
    }
`;

export const FilterHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-left: 24px;
    margin-top: 11px;
    margin-right: 24px;
    margin-bottom: 7px;
`;
export const FilterFooter = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    padding-right: 14px;
    padding-left: 14px;
    padding-top: 1rem;
    padding-bottom: 1rem;
    background: #ffff;
    position: static;
    bottom: 0px;
    box-sizing: border-box;
    width: 100%;
    height: 10%;
`;

export const FooterCloseButton = styled.button`
    height: 38px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    border: 1px solid #1010eb;
    background: #ffff;
    align-content: center;
    width: 40%;
    &:hover {
        cursor: pointer;
    }
`;

export const FooterApplyButton = styled.button`
    height: 38px;
    background: ${(props) => (props.applyButton ? '#1010EB' : '#3c3c3c')};
    border-radius: 5px;
    display: flex;
    justify-content: center;
    width: 40%;
    opacity: 1;
    border: none;
    &:hover {
        cursor: pointer;
    }
`;

export const TextBold = styled.div`
    text-align: left;
    font-family: AvenirNextWorld Demi;
    color: ${(props) => props.color};
    font-size: 15px;
    margin-top: 0px;
    margin-bottom: 0px;
    letter-spacing: -0.12px;
    display: flex;
    align-self: center;
    margin: 0;
    padding: 0;
`;

export const FilterBlock = styled.div`
    top: 5rem;
    right: 2rem;
    ${media.smalDevice`
		top: ${({ isOrderResultPopUp }) => (isOrderResultPopUp ? '7%' : '0')};
		left: ${({ isOrderResultPopUp }) => !isOrderResultPopUp && '0'};
		margin-top:0;
        right:${({ isOrderResultPopUp }) =>
            isOrderResultPopUp ? '15px' : '0'};
	`}
    z-index: 3000;
    background: #f5f5f5;
    opacity: 1;
    position: ${({ isOrderResultPopUp }) => isOrderResultPopUp && 'absolute'};
`;

export const FooterWrapper = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-evenly;
`;
export const EmptyBox = styled.div`
    margin: 5%;
    ${media.smalDevice`
        margin: 150px;
    `}
    ${media.mobileDevice`
        margin: ${({ mobileMargin }) => mobileMargin};
    `}
`;
